import { EntityAuditTrailDescriptor } from 'pages/audit-trail/entity/entityAuditTrail';
import { useGetInvoiceAuditTrailAuthorsQuery, useLazyGetInvoiceAuditTrailEntriesQuery } from 'store/api/audit-trail';

export const INVOICE_AUDIT_TRAIL: EntityAuditTrailDescriptor = {
    localeNamespace: 'audit-trail.invoice',
    classifierCodes: [
        'INVOICE_STATUS_TYPE',
        'INVOICE_PAYMENT_STATUS_TYPE',
        'VAT_CALCULATION_TYPE',
        'TIMECARD_ACTIVITY_TYPE',
    ],
    categories: ['FIELD_CHANGES', 'STATUS_CHANGES', 'STRUCTURAL_CHANGES', 'OPENED'],
    useLazyEntriesQuery: useLazyGetInvoiceAuditTrailEntriesQuery,
    useAuthorsQuery: useGetInvoiceAuditTrailAuthorsQuery,
};
